export default __webpack_public_path__ + "ce1cb569c422615da9f40d1bd748f3df.ogg";